import * as actionTypes from "./actionTypes";
import { offerService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function getOffers({
  page = constants.GET_ALL_ITEMS,
  filter,
  reset,
  show_expired_flag = 1,
} = {}) {
  return async (dispatch) => {
    try {
      if (reset == true) dispatch({ type: actionTypes.RESET_OFFERS });

      dispatch({ type: actionTypes.FETCH_OFFERS });
      const response = await offerService.getOffers(
        page,
        filter,
        show_expired_flag
      );
      const data = response.data;
      dispatch({
        type: actionTypes.FETCH_OFFERS_SUCCESS,
        payload: {
          offers: data.data,
          total: data.quantity,
          pageSize: data.pageSize,
        },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_OFFERS_FAILURE);
    }
  };
}

export function resetOffers() {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.RESET_OFFERS,
    });
  };
}

export function getOffer(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_OFFER });
      dispatch({ type: actionTypes.FETCH_OFFER });

      const response = await offerService.getOffer(id);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FETCH_OFFER_FAILURE,
          payload: { error: data.message },
        });

        return;
      }
      dispatch({
        type: actionTypes.FETCH_OFFER_SUCCESS,
        payload: { offer: data },
      });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.FETCH_OFFER_FAILURE);
    }
  };
}

export function createOffer(offer) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.CREATE_OFFER });

      const response = await offerService.newOffer(offer);
      const data = response.data;
      dispatch({
        type: actionTypes.CREATE_OFFER_SUCCESS,
        payload: {
          offer: data,
        },
      });

      dispatch({ type: actionTypes.RESET_CREATE_OFFER });
    } catch (error) {
      errorHelper.handle(error.dispatch, actionTypes.CREATE_OFFER);
    }
  };
}

export function uploadOfferImage(id, image) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPLOAD_IMAGE_OFFER });

      const response = await offerService.uploadImage(id, image);
      const data = response.data;

      dispatch({
        type: actionTypes.UPLOAD_IMAGE_OFFER_SUCCESS,
        payload: {
          imageUrl: data.imageUrl,
        },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.UPLOAD_IMAGE_OFFER_FAILURE
      );
    }
  };
}
export function deleteOffer(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_OFFER });
      const response = await offerService.deleteOffer(id);

      dispatch({
        type: actionTypes.DELETE_OFFER_SUCCESS,
        payload: {
          offer: { id },
        },
      });
      dispatch({ type: actionTypes.RESET_DELETE_OFFER });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.DELETE_OFFER_FAILURE);
    }
  };
}
export function updateOffer(id, offer) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.UPDATE_OFFER });

      const response = await offerService.updateOffer(id, offer);
      const data = response.data;

      dispatch({
        type: actionTypes.UPDATE_OFFER_SUCCESS,
        payload: { offer: data },
      });

      dispatch({ type: actionTypes.RESET_UPDATE_OFFER });
    } catch (error) {
      errorHelper.handle(error, dispatch, actionTypes.UPDATE_OFFER_FAILURE);
    }
  };
}

export function deleteOfferImage(id) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.DELETE_IMAGE_OFFER });
      await offerService.deleteImage(id);

      dispatch({
        type: actionTypes.DELETE_IMAGE_OFFER_SUCCESS,
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.DELETE_IMAGE_OFFER_FAILURE
      );
    }
  };
}

export function resetOffer() {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.RESET_OFFER,
    });
  };
}

export function resetUpdateOffer() {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.RESET_UPDATE_OFFER,
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/offer/actions.js